/* eslint-disable react/jsx-no-comment-textnodes */
import React, { Fragment, useState } from "react";
import PropTypes from "prop-types";
import { mandarMailJack } from "./services";
import { Form, Col, Button, Image } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import ReactGA from "react-ga";
import "./styles.css";

const FormularioComponent = (props) => {
  const [validated, setValidated] = useState(false);
  const [contacto, guardarContacto] = useState({
    nombre: "",
    correo: "",
    mensaje: "",
  });

  const actualizarState = (e) => {
    guardarContacto({
      ...contacto,
      [e.target.name]: e.target.value,
    });
  };

  const submitCita = (e) => {
    ReactGA.event({
      category: "Button",
      action: "Se ha dado click en el apartado de galería",
    });
    e.preventDefault();

    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.preventDefault();
      e.stopPropagation();
    }

    if (form.checkValidity() === true) {
      mandarMailJack(contacto, props.cambiarIdioma);
    }

    setValidated(true);
  };

  const { nombre, correo, mensaje } = contacto;

  return (
    <Fragment>
      <div className="contacto-formulario-contenedor">
        <div className="img-contenedor-movil">
          <div className="informacion-contacto-logo">
            <div className="contacto-logo">
              <Image src="./assets/contacto/Estampilla-Jack.png" />
            </div>
          </div>
        </div>
        <div className="titulo-formulario">
          {props.cambiarIdioma ? (
            <Fragment>
              <div> contactar </div>{" "}
              <div>
                a <span> jack</span>
              </div>
            </Fragment>
          ) : (
            <Fragment>
              <div> contact </div>{" "}
              <div>
                <span> jack</span>
              </div>
            </Fragment>
          )}
        </div>
        <Form
          align="left"
          noValidate
          validated={validated}
          onSubmit={submitCita}
        >
          <Form.Row className="form-parte-uno">
            <Col md={12} lg={6}>
              <Form.Label>
                {" "}
                <span> / / / </span>&nbsp;{" "}
                {props.cambiarIdioma ? "nombre" : "name"}
              </Form.Label>
              <Form.Control
                type="text"
                value={nombre}
                name="nombre"
                onChange={actualizarState}
                required
              />
              <Form.Control.Feedback type="invalid">
                Campo requerido
              </Form.Control.Feedback>
            </Col>
            <Col md={12} lg={6}>
              <Form.Label>
                <span> / / / </span>&nbsp;{" "}
                {props.cambiarIdioma ? "correo" : "mail"}
              </Form.Label>
              <Form.Control
                type="text"
                value={correo}
                name="correo"
                onChange={actualizarState}
                required
              />
              <Form.Control.Feedback type="invalid">
                Campo requerido
              </Form.Control.Feedback>
            </Col>
          </Form.Row>
          <Form.Row>
            <Col xs={12}>
              <Form.Group controlId="ControlTextarea1" align="left">
                <Form.Label>
                  <span> / / / </span>&nbsp;
                  {props.cambiarIdioma ? "mensaje" : "message"}
                </Form.Label>
                <Form.Control
                  type="text"
                  as="textarea"
                  rows="3"
                  value={mensaje}
                  name="mensaje"
                  onChange={actualizarState}
                  required
                />
                <Form.Control.Feedback type="invalid">
                  Campo requerido
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Form.Row>
          <Form.Row>
            <Col md={3} align="right"></Col>
            <Col md={3} align="right">
              <div id="mensaje-enviado"></div>
            </Col>
            <Col md={3} align="right"></Col>
            <Col md={3} align="right">
              <div className="formulario-boton">
                <div id="content-boton">
                  <Button variant="primary" type="submit">
                    {props.cambiarIdioma ? "enviar" : "send"} &nbsp;&nbsp;{" "}
                    <span>&#128898;</span>
                  </Button>
                </div>
              </div>
            </Col>
          </Form.Row>
        </Form>
      </div>
    </Fragment>
  );
};

FormularioComponent.propTypes = {
  cambiarIdioma: PropTypes.bool,
};

export default FormularioComponent;
